import {useAuth} from "../../services/use-auth";
import {Route, Redirect} from "react-router-dom";

export default function PrivateRoute({ children, ...rest }) {
    let auth = useAuth();
    return (
        <Route
            {...rest}
            render={({ location }) =>
                auth.user ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/account/login",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
}
